import { combineReducers } from 'redux';

import auth from './auth';
import availabilitychoice from './availabilitychoice';
import cities from './cities';
import content from './content';
import currency from './currency';
import hotelcontent from './hotelcontent';
import hotelrates from './hotelrates';
import hotelroomschoice from './hotelroomschoice';
import hotels from './hotels';
import hotelsearchdata from './hotelsearchdata';
import locale from './locale';
import message from './message';
import order from './order';
import pages from './pages';
import paxchoice from './paxchoice';
import payment from './payment';
import posts from './posts';
import promocode from './promocode';
import tophotels from './tophotels';
import toptours from './toptours';
import tours from './tours';
import voucher from './voucher';
// ##### 24-02-26 Komarov
import hotelchoiceintours from './hotelchoiceintours';
import routes from './routes';
import setDeviceType from './setDeviceType';
import tourcontents from './tourcontents';
import whitelabel from './whitelabel';
import setCurrentUrl from './setCurrentUrl';
// ##### 24-07-22 Komarov
import setOthersName from './setOthersName';
// ##### Komarov 2025-09-18
import setIpInfo from './setIpInfo';
import setData from './setData';
import setLanguage from './setLanguage';
// ##### 24-05-10 Komarov
import hotelsContext from './hotelsContext';
// ##### 24-05-29 Komarov
import setSitePageListSection from './setSitePageListSection';
// ##### 24-06-17 Komarov
import gallery from './gallery';
// ##### 24-11-08 Komarov
import company from './company';
// ##### 24-12-23 Komarov
import siteCypherCodeData from './siteCypherCodeData';
// ##### 24-07-24 Komarov
import setCountry from './setCountry';
// ##### 25-04-24 Komarov
import devMode from './devMode';
// ##### Komarov 2025-07-31
import searchHotelsLinks from './searchHotelsLinks';
// ##### Komarov 2025-08-05
import pagesRedux from './pagesRedux';

//{combineReducers} - это библиотека из редакса для комбинации нескольких редьюсеров
const root_reducer = combineReducers({
  posts,
  hotels,
  tours,
  cities,
  content,
  pages,
  toptours,
  tophotels,
  auth,
  order,
  voucher,
  payment,
  message,
  paxchoice,
  hotelcontent,
  hotelrates,
  hotelroomschoice,
  availabilitychoice,
  hotelsearchdata,
  locale,
  currency,
  promocode,
  // ##### 24-02-26 Komarov
  whitelabel,
  routes,
  hotelchoiceintours,
  tourcontents,
  deviceType: setDeviceType,
  currentUrl: setCurrentUrl,
  // ##### 24-07-22 Komarov
  othersName: setOthersName,
  // ##### Komarov 2025-09-18
  ipInfo: setIpInfo,
  language: setLanguage,
  // ##### 24-07-24 Komarov
  country: setCountry,
  data: setData,
  hotelsContext,
  // ##### 24-05-29 Komarov
  sitePageListSection: setSitePageListSection,
  // ##### 24-06-17 Komarov
  gallery,
  // ##### 24-11-08 Komarov
  company,
  // ##### 24-12-23 Komarov
  siteCypherCodeData,
  // ##### 25-04-24 Komarov
  devMode,
  searchHotelsLinks,
  pagesRedux,
});

export default root_reducer;
